import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

import { RangeModifier } from 'ha/ui/next/DatePicker';

import {
  getToday,
  isDayBetween,
  addDays,
  isBefore,
  diffDay,
  NO_END,
  NO_START,
} from '@ha/date';
import calculateMinimumSelectedDays from './calculateMinimumSelectedDays';

interface ExclusionDate {
  from: string;
  to: string;
}

type ExclusionsType = ExclusionDate | RangeModifier;

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

const isInCorrect = (date: Date | string): boolean =>
  dayjs(date).isSameOrAfter(NO_END) || dayjs(date).isSameOrBefore(NO_START);

export default (
  ranges: ExclusionsType[] = [],
  minimalPeriod = 0,
  minimalDate: string = getToday(),
): string | null => {
  if (!ranges.length) {
    return minimalDate;
  }

  const sorted = ranges.sort(
    (range1: ExclusionsType, range2: ExclusionsType) =>
      Number(dayjs(range1.from)) - Number(dayjs(range2.from)),
  );
  let guess: string = minimalDate;

  sorted.some(({ from, to }) => {
    if (isBefore(guess, from)) {
      const minimumSelectedDays = calculateMinimumSelectedDays(
        guess,
        minimalPeriod,
      );
      const diffInDays = diffDay(from, guess);
      const doesDayFit = diffInDays >= 0 && diffInDays > minimumSelectedDays;

      if (doesDayFit) {
        return true;
      }

      guess = addDays(dayjs(to).toISOString(), 1);
    }
    if (isDayBetween(from, to, guess)) {
      guess = addDays(dayjs(to).toISOString(), 1);
    }

    return false;
  });

  return isInCorrect(guess) ? null : guess;
};
